__webpack_require__.p = "https://certificate.quantstamp.com/full/apyx-apx-usd-apy-usd-bridged-token/22bc8135-312c-452d-b885-754645a97076/";